"use client";

import { motion } from "framer-motion";

const AgentDifferentiationBlock = () => {
  return (
    <section className="w-full bg-[#0B1220] py-24 sm:py-32 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto text-center flex flex-col items-center">
        {/* Eyebrow */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="inter-medium text-sm tracking-wide uppercase text-white/60 mb-6"
        >
          Differentiation
        </motion.p>

        {/* Headline */}
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="judson-regular text-[38px] sm:text-[52px] md:text-[64px] leading-[1.05] text-white max-w-5xl"
        >
          Built to support agents
          <br />
          <span className="text-white/60">not replace them.</span>
        </motion.h2>

        {/* Divider */}
        <div className="h-px w-full max-w-3xl bg-white/10 my-14" />

        {/* Body */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-4xl inter-regular text-lg leading-relaxed text-white/80"
        >
          AskLocal doesn’t compete with agents. It strengthens them. Our platform
          is designed to amplify your value, reinforce your expertise, and help
          you deliver a more transparent, professional client experience
          without added cost or complexity.
        </motion.p>

        {/* Accent line */}
        <div className="mt-12 h-[3px] w-20 rounded-full bg-[#EB9C2C]" />
      </div>
    </section>
  );
};

export default AgentDifferentiationBlock;
